import { render, staticRenderFns } from "./QuickLabelTartuflanghe.vue?vue&type=template&id=2e1d7c68&scoped=true&"
import script from "./QuickLabelTartuflanghe.vue?vue&type=script&lang=js&"
export * from "./QuickLabelTartuflanghe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d7c68",
  null
  
)

export default component.exports